import { ISwitchTab, SearchType } from '@studyportals/search-page-interface';

export class SwitchTab implements ISwitchTab {
	public readonly label: string;
	public readonly type: SearchType;

	public constructor(label: string, type: SearchType) {
		this.label = label;
		this.type = type;
	}

	public static forSearchType(searchType: SearchType): SwitchTab {
		switch (searchType) {
			case SearchType.SCHOLARSHIP:
				return new SwitchTab('Scholarships', SearchType.SCHOLARSHIP);
			case SearchType.ORGANISATION:
				return new SwitchTab('Universities', SearchType.ORGANISATION);
			default:
				return new SwitchTab('Programmes', SearchType.STUDY);
		}
	}

	public static forSearchTypes(searchTypes: readonly SearchType[]): SwitchTab[] {
		return searchTypes.map((t) => SwitchTab.forSearchType(t));
	}
}
